import Labequipments from "../../assets/img/productCategory/Labequipments.png";
import LabSupplies from "../../assets/img/productCategory/LabSupplies.png";
import Medicalequipments from "../../assets/img/productCategory/Medicalequipments.png";
import MolecularDiagnostics from "../../assets/img/productCategory/MolecularDiagnostics.png";
import SecurityDetectors from "../../assets/img/productCategory/SecurityDetectors.png";
import { useMediaQuery } from "react-responsive";

function Banner(props) {
  let { title, banner_text, image } = props;
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const overlayStyle = {
    position: "absolute",
    top: isTabletOrMobile ? "7%" : "20%",
    left: "30px",
    width: "40%",
    fontSize: isTabletOrMobile && 12,
  };
  const getBannerImage = (title) => {
    switch (title) {
      case "Lab Equipment":
        return Labequipments;
      case "Lab Supplies":
        return LabSupplies;
      case "Medical Devices":
        return Medicalequipments;
      case "Molecular Diagnostics & Genomic Systems":
        return MolecularDiagnostics;
      case "Security Detectors":
        return SecurityDetectors;
    }
  };

  return (
    <div>
      <div style={overlayStyle}>
        <h1>{title}</h1>
        <p>{!isTabletOrMobile && banner_text}</p>
      </div>
      <img
        alt="Hero"
        src={image ? image : getBannerImage(title)}
        style={{ height: "auto", width: "100%" }}
      />
    </div>
  );
}

export default Banner;
